import { FaArrowRight } from 'react-icons/fa';
import { EVENT } from '../data/eventInfo';

/**
 * One switch for every Register call to action on the site.
 * While EVENT.registrationOpen is false the button reads "Register Soon"
 * and does nothing, so nobody books the old dates by accident.
 */
export default function RegisterCTA({ className = 'cta-button', label = 'Register', arrow = true }) {
  if (!EVENT.registrationOpen) {
    return (
      <span className={`${className} cta-soon`} aria-disabled="true">
        Register Soon
      </span>
    );
  }

  return (
    <a
      href={EVENT.registerUrl}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
    >
      {label}
      {arrow && <FaArrowRight style={{ marginLeft: '0.4rem' }} />}
    </a>
  );
}
